import { render, staticRenderFns } from "./PropostaAnalysis.vue?vue&type=template&id=5daf69bf&scoped=true"
import script from "./PropostaAnalysis.vue?vue&type=script&lang=js"
export * from "./PropostaAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PropostaAnalysis.vue?vue&type=style&index=0&id=5daf69bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf69bf",
  null
  
)

export default component.exports